import React from 'react';
import { Flex, Box, Text, Button, Link } from 'rebass/styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Checkpoint from '../components/Checkpoint';

const Eligibility = ({ onClick }) => (
  <StaticQuery
    query={graphql`
      query EligibilityQuery {
        contentfulStudyEligibleToPaticipate {
          id
          condition
        }
      }
    `}
    render={data => {
      const { condition } = data.contentfulStudyEligibleToPaticipate;

      return (
        <Box bg="#F8F8F8">
          <Flex flexDirection="column" mx={[4, 5]} py={5}>
            <Box>
              <Text fontSize={1} fontWeight="900" fontFamily="lato" mb={3}>
                You may be eligible to participate in this study if you:
              </Text>
              {condition.map(checkpoint => (
                <Checkpoint content={checkpoint} key={checkpoint} />
              ))}
              <Text fontSize={1} fontWeight="700" fontFamily="lato" my={3}>
                To confirm that you are eligible, begin the sign up processing.
                Participation in this study is completely optional.
              </Text>
              <Button variant="main" mt={3} onClick={onClick}>
                SIGN UP
              </Button>
            </Box>
          </Flex>
        </Box>
      );
    }}
  />
);

export default Eligibility;
